import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TextButton } from '@producer/ui-kit';
import styled from 'styled-components';

import { NavMenu, NavMenuItem } from '../../../components/nav-menu';
import { uiStore } from '../../../core/stores/ui-store';
import { useAuth } from '../../../workos-auth';

const mobileMenu = [
  {
    key: 'profile',
    label: 'Profile',
    href: `./profile`,
  },
  {
    key: 'notifications',
    label: 'Notifications',
    href: `./notifications`,
  },
  {
    key: 'workspaces',
    label: 'Workspaces',
    href: `./workspaces`,
  },
];

export const MobileUserSettingsNavigation = () => {
  const location = useLocation();
  const { signOut } = useAuth();
  const pathname = location.pathname.split('/');

  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Personal settings',
    };

    uiStore.showBack = true;
  }, []);

  return (
    <Container>
      <NavMenu>
        {mobileMenu.map(({ key, label, href }) => (
          <NavMenuItem
            key={key}
            to={href}
            state={location.state}
            label={label}
            isActive={(pathname.length === 4 && key === 'profile') || pathname.includes(key)}
          />
        ))}
      </NavMenu>

      <TextButton text="Logout" type="button" onClick={() => signOut()} />
    </Container>
  );
};

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 1.6rem;
`;
